module.exports = "/images/vendala.png?65431f53f2e00282e9b7979701c30440";